import Modal from '@/components/common-modal/modal';
import { ClientDashboard, PageStyle, Link, Clipboard, Button, Tooltip, ErrorPages, CareerSettingAction, 
          useRouter, useState, REDIRECT, CAREER_SETTING, ConfirmationModal, closeModalUsingState, motion,
          PAGE_ANIMATION_OPTIONS, QuickAdd, redirectToCareerPage, useEffect, ActivitiesAction, useSWR, getCustomizeCareerData, SidebarAction, clearSWRCache, SkipModal, useTranslation, ButtonStyle } from '@/imports-files/pages/career/career-setting';

function CareerSetting(props)
{
    clearSWRCache('career_setting_data')
    const router                                    =     useRouter();
    const [apiError, setApiError]                   =     useState(null);
    const errorPages                                =     new ErrorPages()
    const { t, i18n }                               =     useTranslation();
    const careerSettingAction                       =     new CareerSettingAction(setApiError);
    const activitiesAction                          =     new ActivitiesAction(setApiError);
    const { data, error }                           =     useSWR('career_setting_data', () => { return(getCustomizeCareerData(router, setApiError))});
    const [flagForRerender, setFlagForRerender]     =     useState(0);
    const [clipboardMessage, setClipBoardMessage]   =     useState(t("career_site:settings:copy"));
    const [careerClipboardMessage, setCareerClipBoardMessage]   =     useState(t("career_site:settings:copy"));
    const [link, setLink]                           =     useState(window.location.protocol+'//'+window.location.host+'/careers');
    const [iFrameLink, setIframeLink]               =     useState(window.location.protocol+'//'+window.location.host+'/job-openings');
    const [confirmation, setConfirmation]           =     useState(false);
    const step                                      =     router.query.step
    const isQuickSetup                              =     router.query.step && router.query.step == 'careers_page' ? true : false
    const [skipModal, setSkipModal]                 =     useState(false);
    const [isPublished, setIsPublished]             =     useState(false);
    const [isLoading, setIsLoading]                 =     useState(true);

    useEffect(()=>{
      if(data)
      {
        setIsPublished(data.career_page_published)
        setIsLoading(false)
         if(isQuickSetup)
          setTimeout(() => {
          new SidebarAction().subsidebarQuickSetupChangeIcon(data.sidebar_options.complete_steps, 'careers_page');
        }, 750);
      }
    }, [data])

    if(errorPages.handleErrorCodes(apiError?.status))
    {
      var renderPage  =  ( apiError) ? errorPages.renderPage(apiError?.status, router) : null;
      return renderPage; 
    } 
    if(isLoading) return "";
    return (
      <motion.div key={router.route} initial="pageInitial" animate="pageAnimate" variants={PAGE_ANIMATION_OPTIONS}>
       <div className={`JobListPage TeamList DashboardPageContent ${PageStyle.JobList} ${PageStyle.NewJob}`}>
       <div className={PageStyle.NewJob__Container}>
       <div className={PageStyle.ClientCompany__TopSection2}>
          <div className={PageStyle.JobsApi__QuickAdd}>
            <QuickAdd session={props.session}/>
          </div>
        </div>
       <div className={PageStyle.ClientCompany__FormSection}>
          <h1 className={` mb0 ${PageStyle.ClientCompany__Heading}`}>
            {t("career_site:settings:heading")}: <span className={`${PageStyle.ClientCompany__Company} ${PageStyle.LightBlueColor}`}>{t("career_site:settings:heading_span")} </span>
          </h1>

          <span className={`${PageStyle.PrivacyPolicy__PrivacySubhead}`}>
          {t("career_site:settings:subheading")}
          </span>
       </div>

      {isPublished ?
        <div className={`${PageStyle.CareerSetting} ${PageStyle.Form__TableCol}`}>
          <label className={`${PageStyle.Form__Label} ${PageStyle.Form__FloatingLabel}`}> {t("career_site:settings:link")}</label>
          <div className={`${PageStyle.CareerSetting__Inputbox} ${PageStyle.Form__Input}`}>
            <input
              type="text"
              value={link}
              disabled={false}
            />
            <label>
              <Tooltip className='SimpleTooltip CareerSettingTooltip' content={careerClipboardMessage} background= {'#00325A'} radius={20} padding = {8} placement = "top" fontSize= "12px">
                <span  className  =   "CareerPageTooltip"
                       onClick    =   {()=> careerSettingAction.copyToClipboard(link, setCareerClipBoardMessage)}>
                  <Clipboard className="clipboardsvg" />
                </span>
              </Tooltip>
            </label>
          </div>
        </div>
      :
      <Tooltip className={"CareerSettingsTooltip SimpleTooltip ml0"} content={t("career_site:settings:not_published")} background= {'#00325A'} radius={20} padding = {8} placement = "top" fontSize= "12px">
        <div className={`${PageStyle.CareerSetting} ${PageStyle.Form__TableCol}`}>
          <span className={`${PageStyle.Form__FloatingLabel}`}> {t("career_site:settings:link")}</span>
          <div className={`${PageStyle.CareerSetting__Inputbox} ${PageStyle.Form__Input} ${isPublished ? '' : PageStyle.CareerSetting__Inputbox__disabled}`}>
            <input
              type="text"
              value={""}
              disabled={true}
            />
          </div>
        </div>
      </Tooltip>}

      <div className={`mt30 ${PageStyle.CareerSetting} ${PageStyle.Form__TableCol}`}>
        <label className={`${PageStyle.Form__Label} ${PageStyle.Form__FloatingLabel}`}> {t("career_site:settings:jobs_iframe")}</label>
        <div className={`${PageStyle.CareerSetting__Inputbox} ${PageStyle.Form__Input}`}>
        <input
          type="text"
          value={ careerSettingAction.getIframeValue(iFrameLink)}
        />
        <label>
        <Tooltip className='SimpleTooltip' content={clipboardMessage} background= {'#00325A'} radius={20} padding = {8} placement	= "top" fontSize= "12px">

          <span  className  =   "CareerPageTooltip"
                 onClick    =   {()=> careerSettingAction.copyToClipboard(careerSettingAction.getIframeValue(iFrameLink), setClipBoardMessage)}>
            <Clipboard className="clipboardsvg" />
          </span>

        </Tooltip>

        </label>
        </div>

      </div>

      <div className={PageStyle.CareerSettingButton}>
        {/* <Button buttonstyle={PageStyle.secondarybtnborder} onClick={()=>{console.log('Reset')}}> Reset Careers Page</Button> */}
        <Button buttonstyle={PageStyle.primarybtn} onClick={() => redirectToCareerPage()}>{t("button:customise_careers_page")}</Button>
      </div>


      {isQuickSetup && <div className={PageStyle.NewJob__SubmitSection}>
        <Button buttonstyle  =  {PageStyle.secondarybtnborder}
                type         =  "button"
                onClick      =  {() => { setSkipModal(true) }}
        >
     {t('button:skip')}
        </Button>

        <Button buttonstyle  = {PageStyle.primarybtn}
                type         = "button"
                onClick={()=>{ activitiesAction.nextOnboardingStep(step, router) }}
        >
       {t('button:next')}
        </Button>
      </div>}

      </div>
      </div>

      {skipModal && <SkipModal setBtnPopup={setSkipModal} router={router}></SkipModal>}
      {/* -------------------- UNSUCCESSFUL REASONS DELETE MODAL -------------------- */}
      {confirmation && (
        <Modal
          type="confirmation"
          message={t('modal:confirmation:delete:reset_career_page')}
          closeModal={() => {
            closeModalUsingState(false, setConfirmation);
          }}
          btnAction={() => {
            careerSettingAction.resetCarrerPage(
              setFlagForRerender,
              setConfirmation
            );
          }}
          texts={{
            button2_text: t('button:reset')
          }}
        />
      )}
      {/* -------------------- UNSUCCESSFUL REASONS DELETE MODAL -------------------- */}
      </motion.div>      
    )

}

CareerSetting.layout = ClientDashboard;
export default CareerSetting;